export default __webpack_public_path__ + "static/media/prototyping-principles.e52c021f.svg";